import {
  React,
  Component,
  withCookies
} from 'imports/CommonImports';

import {
  Dialog,
  TextField
} from 'material-ui';

import {
  PrimaryButtonFlat,
  SecondaryButtonFlat,
  CancelButtonFlat
} from 'imports/DesignImports';

const styles = {
  actionsContainer: {
    display: 'flex',
    padding: '0',
  },
  buttonLabel: {
    color: '#FFFFFF',
  },
  contentContainer: {
    width: '35%',
  },
  centerText: {
    textAlign: 'center',
  },
  button: {
    width: '33.33%',
    borderRadius: '0',
  },
  justificationContainer: {
    display: 'flex',
    justifyContent: 'center',
  }
}
class SignatureDialog extends Component {
  constructor(props){
    super(props);
    this.state = {
      open: true,
      token: this.props.cookies.get('token'),
      justification: '',
      error: '',
    };
  }

  handleSign= () => {
    //Send signature
    this.props.sign('signed', this.state.justification)
    this.handleClose();
  };

  handleNoSign= () => {
    //Send NO signature
    if(this.state.justification === ''){
      this.setState({error: 'Debes ingresar una justificación'})
    }
    else{
      this.setState({error: ''})
      this.props.sign('nosigned', this.state.justification)
      this.handleClose();
    }
  };

  handleCancel = () => {
    this.props.cancel()
    this.handleClose();
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <SecondaryButtonFlat
        label='Volver'
        style={styles.button}
        onClick={this.handleCancel}
      />,
    <CancelButtonFlat
        label='No firmar'
        style={styles.button}
        onClick={this.handleNoSign}
      />,
    <PrimaryButtonFlat
        label='Firmar'
        style={styles.button}
        onClick={this.handleSign}
      />,
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.open}
          actionsContainerStyle={styles.actionsContainer}
          contentStyle={styles.contentContainer}
          onRequestClose={this.handleCancel}
        >
          <h2 style={styles.centerText}>Firma de proyecto</h2>
          <h3 style={styles.centerText}>Puedes firmar o no firmar el proyecto. Si no lo firmas es porque tiene errores y se notificará al líder que debe modificarlo.</h3>
          <div style={styles.justificationContainer}>
            <TextField
              id="justification"
              value={this.state.justification}
              onChange={this.handleTextChange}
              hintText="Ingresa la justificación de tu decisión"
              multiLine={true}
              fullWidth={true}
              rowsMax={2}
              errorText={this.state.error}
            />
          </div>
      </Dialog>
      </div>
    );
  }
  handleTextChange = (event) => {
    this.setState({justification: event.target.value,});
  };
}

export default withCookies(SignatureDialog);



// WEBPACK FOOTER //
// ./src/components/design/SignDialog.js